import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// (FIX) The component is now a named export
export const AdminUserProgressModal = ({ user, onCancel }) => {
    const [progress, setProgress] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProgress = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.get(`/api/admin/users/${user.google_id}/progress`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProgress(response.data);
        } catch (err) {
            setError('Failed to load user progress.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }, [user.google_id]);

    useEffect(() => {
        fetchProgress();
    }, [fetchProgress]);

    const handleResetProgress = async (courseId) => {
        if (window.confirm('Are you sure you want to reset all progress for this user on this course? This cannot be undone.')) {
            try {
                const token = localStorage.getItem('app_token');
                await axios.delete(`/api/admin/users/${user.google_id}/progress/${courseId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                fetchProgress(); // Refresh the progress data
            } catch (err) {
                alert('Failed to reset progress.');
                console.error(err);
            }
        }
    };

    const calculatePercentage = (completed, total) => {
        if (total === 0) return 0;
        return ((completed / total) * 100).toFixed(0);
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal-content" style={{ maxWidth: '800px' }}>
                <h2>Course Progress for {user.name}</h2>
                
                {isLoading ? <p>Loading progress...</p> : error ? <p className="error-message">{error}</p> : (
                    <div className="admin-table-container">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Course Title</th>
                                    <th style={{width: '200px'}}>Progress</th>
                                    <th>Completed / Total</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {progress.length > 0 ? progress.map(item => {
                                    const percentage = calculatePercentage(item.completed_lectures, item.total_lectures);
                                    return (
                                        <tr key={item.course_id}>
                                            <td>{item.title}</td>
                                            <td>
                                                <div style={{ background: '#e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                                                    <div style={{ width: `${percentage}%`, background: '#4f46e5', color: 'white', textAlign: 'center', padding: '2px 0', fontSize: '0.8rem' }}>
                                                        {percentage}%
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.completed_lectures} / {item.total_lectures}</td>
                                            <td className="admin-table-actions">
                                                <button 
                                                    onClick={() => handleResetProgress(item.course_id)} 
                                                    className="action-btn delete" 
                                                    title="Reset Course Progress"
                                                >
                                                    <span className="material-icons">refresh</span>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan="4" style={{ textAlign: 'center' }}>This user has not started any courses.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="form-actions">
                    <button type="button" onClick={onCancel} className="btn-secondary">Close</button>
                </div>
            </div>
        </div>
    );
};

export default AdminUserProgressModal;
